import { render, staticRenderFns } from "./CasePreview.vue?vue&type=template&id=ed946b18&scoped=true"
import script from "./CasePreview.vue?vue&type=script&lang=js"
export * from "./CasePreview.vue?vue&type=script&lang=js"
import style0 from "./CasePreview.vue?vue&type=style&index=0&id=ed946b18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed946b18",
  null
  
)

export default component.exports